import { useState, useEffect } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import Select from "react-select";
import { config, encodeBase64RequestBody } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const ContactAdd = () => {
  const { id_company } = useParams();
  const [ companies, setCompanies ] = useState(null);
  const [ companyGroup, setCompanyGroup ] = useState(null);
  const [ contactName, setContactName ] = useState('');
  const [ contactEmail, setContactEmail ] = useState('');
  const [ contactPhone, setContactPhone ] = useState('');
  const [ contactPosition, setContactPosition ] = useState('');
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getCompanies();
  }, []);

  useEffect(() => {
    if (companies && id_company) {
      changeCompanyData(id_company);
    }
  }, [companies]);

  const getCompanies = async () => {
    try {
      const requestCompanies = {
        "company_status": 'Active'
      };
      const fetchCompanies = await jwtFetch(config.ENDPOINT + 'get/company', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestCompanies)
      });
      const responseCompanies = await fetchCompanies.json();
      if (responseCompanies.status === 200) {
        for (let i in responseCompanies.data) {
          responseCompanies.data[i].value = responseCompanies.data[i].id_company;
          responseCompanies.data[i].label = responseCompanies.data[i].company_name;
        }
        setCompanies([...responseCompanies.data].sort((a, b) => (a.company_name || '').localeCompare(b.company_name || '')));
      } else {
        alert(responseCompanies.message);
      }
    } catch (error) {
      console.error('Error in getCompanies:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const changeCompanyData = (value) => {
    const company = companies.find(company => company.id_company == value);
    setCompanyGroup(company);
  }
  
  const submitContactAdd = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);
      const crmUser = JSON.parse(localStorage.getItem('crmUser'));

      const requestContactAdd = {
        "company_id": companyGroup.value,
        "cperson_name": contactName,
        "cperson_email": contactEmail,
        "cperson_phone": contactPhone,
        "cperson_position": contactPosition,
        "cperson_status": 'Active',
        "created_on": format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        "created_by": crmUser.user_keyid,
      }
      const fetchContactAdd = await jwtFetch(config.ENDPOINT + 'create/contact_person', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestContactAdd)
      });
      const responseContactAdd = await fetchContactAdd.json();
      if (responseContactAdd.status === 200) {
        window.location.href = '/client/contact';
      } else {
        alert(responseContactAdd.message);
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in submitContactAdd:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }

  return (
    <div id="contact-add">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="client"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="fs-24 mb-3"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left"/></button> Contact Add</div>
                  <form className="row" onSubmit={(e) => submitContactAdd(e)}>
                    <div className="col-md-6">
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Company Group <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <Select value={companyGroup} options={companies} placeholder="" onChange={(e) => changeCompanyData(e.value)} required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Name <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={contactName} onChange={(e) => setContactName(e.target.value)} required />
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Email <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} required />
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Phone <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={contactPhone} onChange={(e) => setContactPhone(e.target.value)} required />
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Position <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={contactPosition} onChange={(e) => setContactPosition(e.target.value)} required />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="d-flex justify-content-end mb-4">
                        <button className="btn btn-sm btn-link text-danger" type="button" onClick={() => window.location.href = '/client/contact'}>Cancel</button>
                        <button className="btn btn-sm btn-primary ms-2" type="submit" disabled={isLoadingSubmit}>{isLoadingSubmit ? 'Loading...' : 'Save'}</button>
                      </div>
                    </div>
                  </form>
                </section>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactAdd;


